export const LOCAL_DEBUG = process.env.REACT_APP_LOCAL_DEBUG === 'true';
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;